import React, { useState } from "react";
import { Badge } from "../components/ui/badge";
import { CircleCheck, CircleX } from "lucide-react";
import Datatable from "../components/Datatable";
import CustomerDropdown from "../components/CustomerDropdown";
import { Link } from "react-router";
import SearchInput from "../components/SearchInput";

const Resources = () => {
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [selectedId, setSelectedId] = useState(null);
  const [formModalOpen, setFormModalOpen] = useState(false);

  const limit = 10;

  // const { data, isLoading, error } = useGetInstancesListQuery({
  //   limit,
  //   offset: (page - 1) * limit,
  //   search,
  // });

  // temp ---------------

  const data = [
    {
      id: "i-0a12b34c56d78e910",
      instanceId: "i-0a12b34c56d78e910",
      status: "ok",
      project: "AI Test Research",
      startDate: "2025-01-10 14:32:00",
      customer: "Demo Organization",
      account: "ACC-00001",
    },
    {
      id: "i-0b98c76d54e32f110",
      instanceId: "i-0b98c76d54e32f110",
      status: "ok",
      project: "AI Test Research",
      startDate: "2025-01-11 09:10:00",
      customer: "Demo Organization",
      account: "ACC-00002",
    },
  ];

  // --------------------

  const handleSearch = (e) => {
    setSearch(e.target.value);
    setPage(1);
  };

  const handleView = (id) => {
    setSelectedId(id);
    setFormModalOpen(true);
  };

  const totalPages = data ? Math.ceil(data?.pagination?.total ?? 0 / limit) : 0;

  const columns = [
    {
      id: "instanceId",
      label: "Instance ID",
      headClass: "min-w-[150px]",
      cellClass: "font-medium",
      render: (row) => (
        <Link to="/monitoring-dashboard" className="text-blue-600">
          {row.instanceId}
        </Link>
      ),
    },
    {
      id: "project",
      label: "Project",
      headClass: "min-w-[150px]",
      cellClass: "truncate",
    },
    {
      id: "customer",
      label: "Customer",
      headClass: "min-w-[150px]",
      cellClass: "truncate",
    },
    {
      id: "account",
      label: "Account",
      headClass: "min-w-[150px]",
      cellClass: "truncate",
    },
    {
      id: "status",
      label: "Status",
      render: (row) =>
        row.status === "ok" ? (
          <Badge variant="secondary" className="bg-emerald-500 text-white">
            <CircleCheck />
            OK
          </Badge>
        ) : (
          <Badge variant="secondary" className="bg-rose-500 text-white">
            <CircleX />
            FAILED
          </Badge>
        ),
    },
    {
      id: "startDate",
      label: "Start Date",
      headClass: "min-w-[140px]",
    },
  ];

  return (
    <>
      <div className="space-y-4">
        <div className="flex justify-between items-center">
          <CustomerDropdown showSearch={false} />
          <SearchInput search={search} handleSearch={handleSearch} />
        </div>

        <Datatable
          limit={limit}
          page={page}
          setPage={setPage}
          columns={columns}
          rows={data || []}
          // isLoading={isLoading}
          // error={error}
          total={data?.pagination?.total || 0}
        />
      </div>
    </>
  );
};

export default Resources;
